import { helper } from '@ember/component/helper';
import type { ShipmentStateEnum } from '../types';

export default helper(function shipmentStateProgress(positional: [ShipmentStateEnum]) {
  const state = positional[0];
  switch (state) {
    case 'ORDER_RECEIVED':
      return 20;
    case 'ORDER_PACKED':
      return 40;
    case 'TRANSPORT_ORDER_RECEIVED':
    case 'NOT_DELIVERED':
      return 60;
    case 'SHIPPING_IN_PROGRESS':
      return 80;
    case 'DELIVERED':
      return 100;
    default:
      return 0;
  }
});
